import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34332400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Click Abaixo para iniciar", -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["src"]

import { ref } from 'vue'
import * as CSLiveness from '@studio/csliveness'

interface Response {
  sessionId: string
  image: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const result = ref({
  sessionId: '',
  image: '',
})

const localState = ref({
  error: '',
  onReady: false
})

let sdk = new CSLiveness.Instance("smu-investimento", "T8m2l28BR7h3d0th2xdr71FMAdWQMxBN", '/dist/core-sdk')

sdk.on('onReady', () => {
  localState.value.onReady = true
})

sdk.on('onCompleted', (successResult: Response) => {
  result.value = successResult
})

sdk.on('onError', (typeError: string) => {
  localState.value.error = typeError
})

sdk.initialize()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      disabled: !localState.value.onReady,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(sdk).open()))
    }, _toDisplayString(localState.value.onReady
        ? 'Testar Liveness'
        : 'Inicializando o pacote...'), 9, _hoisted_3),
    (localState.value.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " error: " + _toDisplayString(localState.value.error), 1))
      : _createCommentVNode("", true),
    (result.value.sessionId)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " sessionId: " + _toDisplayString(result.value.sessionId), 1))
      : _createCommentVNode("", true),
    (result.value.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          class: "img-result",
          src: `data:image/jpeg;base64,${result.value.image}`
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}
}

})